import { connect } from 'react-redux';
import { withRouter } from 'hocs/router';
import { notificationActions } from '../../../../../components/notifications/actions/notification';
import satisfactionActions from '../../../actions/satisfaction';
import { CustomizationPageRoute, } from '../../../components/sections/satisfaction/components/EmailCSAT/CustomizationPage/CustomizationPageRoute';
function formatFormValuesForApi(customization) {
    return {
        body: customization.body,
        button_text: customization.actionButtonText,
        look_and_feel: customization.ratingStyle,
        placeholder_text: customization.placeholderText,
        rating_question: customization.ratingQuestion,
        subject: customization.subject,
        thank_you_message: customization.headerText,
        comment_question: customization.subheaderText,
    };
}
const mapDispatchToProps = (dispatch, ownProps) => ({
    loadEmailSettingsAllLevels() {
        dispatch(satisfactionActions.satisfactionLoadEmailAllLevelsSettingsRequest('email'));
    },
    onSubmit(customization) {
        const payload = {
            id: ownProps.params.settingsId,
            customization: formatFormValuesForApi(customization),
            channel: 'email',
            level: 'language',
            language: ownProps.params.language,
        };
        function redirectAfterSettingCreation({ data: { id }, }) {
            if (ownProps.mode === 'create') {
                dispatch(notificationActions.notificationAdd({
                    title: 'Settings successfully created for this language',
                    className: 'success',
                    icon: 'i-done',
                    time: 5000,
                }));
                ownProps.navigate(`/settings/satisfaction/email/${ownProps.params.language}/edit/${id}`);
            }
            if (ownProps.mode === 'edit') {
                dispatch(notificationActions.notificationAdd({
                    title: 'Settings successfully updated for this language',
                    className: 'success',
                    icon: 'i-done',
                    time: 5000,
                }));
            }
        }
        new Promise((resolve, reject) => {
            dispatch(satisfactionActions.satisfactionSaveEmailLanguageLevelSettingsRequest(payload, { resolve, reject }));
        }).then(redirectAfterSettingCreation);
    },
});
export default withRouter(connect(undefined, mapDispatchToProps)(CustomizationPageRoute));
